import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ModeloFernanda from './pages/ModeloFernanda';
import ModeloMariana from './pages/ModeloMariana';
import AgendarVisita from './pages/AgendarVisita';
import LotesEditor from './pages/LotesEditor';
import ConciergeKnowledge from './pages/ConciergeKnowledge';
import './pages/LotesEditor.css';
import AdminLogin from './pages/admin/AdminLogin';
import ProtectedAdminRoute from './pages/admin/ProtectedAdminRoute';
import AvisoPrivacidad from './pages/AvisoPrivacidad';
import Terminos from './pages/Terminos';
import GlobalUI from './components/GlobalUI';
import { trackPageView } from './lib/metaTrack';
import './App.css';
import 'leaflet/dist/leaflet.css';

function ChromeWrapper({ children }) {
  const loc = useLocation();
  const hideChrome = loc.pathname.startsWith('/admin');
  return (
    <>
      {!hideChrome && <GlobalUI />}
      {children}
    </>
  );
}

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return; // permitir anclas (#amenidades, etc.)
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);
  return null;
}

/** Fire Meta Pixel PageView on every SPA route change (initial PV is dispatched
 *  by the inline <head> snippet; this covers subsequent client-side navigations). */
function MetaPixelRouteTracker() {
  const { pathname, search } = useLocation();
  const isFirst = React.useRef(true);
  useEffect(() => {
    if (isFirst.current) {
      // Avoid double-counting the first page view (already fired in index.html)
      isFirst.current = false;
      return;
    }
    trackPageView();
  }, [pathname, search]);
  return null;
}

function App() {
  return (
    <div className="sm-body">
      <BrowserRouter>
        <ScrollToTop />
        <MetaPixelRouteTracker />
        <ChromeWrapper>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/modelo-fernanda" element={<ModeloFernanda />} />
            <Route path="/modelo-mariana" element={<ModeloMariana />} />
            <Route path="/agendar-visita" element={<AgendarVisita />} />
            <Route path="/aviso-privacidad" element={<AvisoPrivacidad />} />
            <Route path="/terminos" element={<Terminos />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin/lotes-editor"
              element={
                <ProtectedAdminRoute>
                  <LotesEditor />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/concierge"
              element={
                <ProtectedAdminRoute>
                  <ConciergeKnowledge />
                </ProtectedAdminRoute>
              }
            />
          </Routes>
        </ChromeWrapper>
      </BrowserRouter>
    </div>
  );
}

export default App;
